import React, {useEffect, useState} from "react";
import {
    Box, Button, Card, CardContent,
    Grid,
    Typography
} from '@deere/fuel-react';
import LaunchIcon from "@material-ui/icons/Launch";
import {DataGrid} from "@mui/x-data-grid";
import {SCORE_OVERRIDE, PAST_PERF_CARD_TITLE, VIEW_PAST_PERFORMANCE} from "../shared/Constants";
import {useStyles} from "../shared/styles/Ratings";
import {useAuthConfig} from "../shared/helper";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

export const RatingsPastPerformanceCard = ({
    pastPerformanceRating,
    supplierNumber,
    functionalArea,
    onPastPerformanceOverview
}) => {
    let authAxios = useAuthConfig();
    const classes = useStyles();
    const [pastPerformanceData, setPastPerformanceData] = useState([]);
    const [isScoreOverride, setIsScoreOverride] = useState(false);

    const normalColumns = [
        {
            field: 'id',
            headerName: 'ID',
            hide: true
        },
        {
            field: 'Category',
            flex: 1,
            headerName: null,
            cellClassName: 'row-highlight',
            renderCell: (params) => {
                return (
                    <Typography display='block' variant="body2" fontWeight="semibold">
                        {params.value}
                    </Typography>
                );
            }
        }
    ];

    const pastPerformanceColumns = pastPerformanceRating.map(item => {
        return {
            field: `fy${item.fiscalYear}`,
            headerName: item.fiscalYear,
            flex: .7,
            renderCell: (params) => {
                return (
                    params.value?.includes("**") ?
                        <Typography display='block' variant="body1">
                            {params.value.substring(0, params.value.indexOf("*"))} <FiberManualRecordIcon
                            style={{color: "#005DB1", fontSize: 10, marginTop: "-.5rem"}}/></Typography>
                        :
                        <Typography display='block' variant="body1">
                            {params.value ?? ''}
                        </Typography>

                );
            }
        }
    })

    const columns = [...normalColumns, ...pastPerformanceColumns]

    const getPastPerformanceData = async () => {
        try {
            const postData = {
                fiscalYear: "current",
                supplierNumber: supplierNumber
            }
            return await authAxios.post(`/pastPerformance`, postData);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        let cancelled = false;
        getPastPerformanceData().then(res => {
            if (cancelled) return;
            setPastPerformanceData(res.data.pastPerformanceList)
            setIsScoreOverride(res.data.isScoreOverridden)
        });
        return () => {
            cancelled = true;
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const rowsData = pastPerformanceData && pastPerformanceData.map((item) => {
        const periodArray = pastPerformanceRating.map(periodItem => {
            return {
                key: `fy${periodItem.fiscalYear}`,
                value: item[`fy${periodItem.fiscalYear}`]
            }
        })
        const periodData = Object.assign({}, ...periodArray.map(o => ({[o.key]: o.value})))
        return {
            id: item.id,
            Category: item.category,
            ...periodData
        }
    })

    return (
        <Grid item xs={8}>
            <Box p={2}>
                <Card>
                    <CardContent style={{paddingBottom: '1.15rem', height: '350px'}}>
                        <Grid container>
                            <Grid item xs={8}>
                                <Typography variant="h4">
                                    {PAST_PERF_CARD_TITLE}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Button
                                    onClick={onPastPerformanceOverview}
                                    startIcon={<LaunchIcon style={{ marginRight: '5px' }} />}
                                    variant="text-inline"
                                >
                                    {VIEW_PAST_PERFORMANCE}
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <DataGrid
                                    rowHeight={37}
                                    className={classes.root}
                                    rows={rowsData}
                                    columns={columns}
                                    hideFooterPagination
                                    hideFooterSelectedRowCount
                                    disableSelectionOnClick
                                    disableColumnSelector={true}
                                    disableColumnFilter
                                    autoHeight={true}
                                />
                            </Grid>
                            {isScoreOverride &&
                            <Grid item xs={12}>
                                <Box display={"flex"} justifyContent="flex-end" mt={1}>
                                    <Typography variant="caption" display="inline">
                                        <FiberManualRecordIcon
                                            style={{color: "#005DB1", fontSize: 10, marginTop: -3}}/> {SCORE_OVERRIDE}
                                    </Typography>
                                </Box>
                            </Grid>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Grid>
    )
}
